import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ displayState }) => {
    return css`    
      span {
        display: none;
      }

      &:hover {
        span {
          display: unset;
        }
        [viewBox="data-subtitle-delete-btn-${displayState?.uuid}"] {
          display: none;
        }
      }
    `;
  }}
`;

export default Wrapper(template)
